var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms-of-service"},[_c('h1',[_vm._v("Terms of Service")]),_vm._l((_vm.sections),function(section,index){return _c('section',{key:index},[_c('h2',[_vm._v(_vm._s(section.title))]),_c('div',{domProps:{"innerHTML":_vm._s(section.content)}})])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }